define('AdvancedSearch.Header.View',
  [
    'advanced_search_header.tpl',
    'SCView',
    'AdvancedSearch.View',
    'AdvancedSearch.SS2Model',
    'Utils'
  ], function (
    Template,
    SCViewComponent,
    AdvancedSearchView,
    AdvancedSearchSS2Model,
    Utils
  ) {
    'use strict';
    var SCView = SCViewComponent.SCView;

    function AdvancedSearchHeader(options) {
      SCView.call(this);

      this.options = options || {};

      this.template = Template;

      this.initialize = function initialize(opt) {
        this.container = opt && opt.container;
        this.layout = this.container && this.container.getComponent('Layout');
        this.advancedSearchConfig = opt.advancedSearchConfig;
        this.model = new AdvancedSearchSS2Model();
      };

      this.initialize(options);
    }

    AdvancedSearchHeader.prototype = Object.create(SCView.prototype);
    AdvancedSearchHeader.prototype.constructor = AdvancedSearchHeader;

    AdvancedSearchHeader.prototype.getChildViews = function () {
      if(Utils.isPhoneDevice()) {
        return {
          'Advanced.Search': function () {
            return new AdvancedSearchView({
              container: this.container,
              advancedSearchConfig: this.advancedSearchConfig,
              model: this.model
            });
          }
        };
      }
      return {};
    };

    AdvancedSearchHeader.prototype.getEvents = function () {
      return {
        'click [data-action="advanced-search"]': 'advancedSearch'
      };
    };

    AdvancedSearchHeader.prototype.advancedSearch = function (e) {
      e.preventDefault();
      var modalView = new AdvancedSearchView({
        container: this.container,
        advancedSearchConfig: this.advancedSearchConfig,
        model: this.model
      });
      this.layout.showContent(modalView, { showInModal: true, options: { className: 'advanced-search-modal' } });
    };

    AdvancedSearchHeader.prototype.getContext = function getContext() {
      return {
        isDesktop: !Utils.isPhoneDevice()
      };
    };

    return AdvancedSearchHeader;
  });
